import packageJson from '../package.json';

import {
  HEALTH_INSURANCE_PRODUCTS,
  TERM_INSURANCE_PRODUCTS
} from './utils/constants';

export const APP_STAGE_DEVELOPMENT = 'dev';
export const APP_STAGE_PRODUCTION = 'production';
export const APP_STAGE_STAGING = 'staging';

type AppConfig = {
  APP_VERSION?: string;
  APP_STAGE?: string;
  // Indicates whether the app is running in development mode
  IS_DEV: boolean;
  // Indicates whether the app is running in production mode
  IS_PROD: boolean;
  COOKIE_DOMAIN?: string;
  INSURANCE_API: string;
  SENTRY_DSN?: string;
  SENTRY_ENV?: string;
  SENTRY_AUTH_TOKEN?: string;
  FB_API_KEY?: string;
  FB_AUTH_DOMAIN?: string;
  FB_DATABASE_URL?: string;
  FB_PROJECT_ID?: string;
  FB_STORAGE_BUCKET?: string;
  FB_MESSAGING_SENDER_ID?: string;
  FB_APP_ID?: string;
  TURN_STILE_TOKEN: string;
  TERM_PRODUCTS: string[];
  HEALTH_PRODUCTS: string[];
  PRODUCTS_NOT_AVAILABLE_ON_FQ: string[];

  BILLDESK_SOURCES: {
    // URL to load the BillDesk SDK in module mode
    module: string;
    // URL to load the BillDesk SDK in nomodule mode
    noModule: string;
    // URL to load the BillDesk CSS
    css: string;
  };

  MLI_DOC_UPLOAD_URL: string;

  DARK_MODE?: boolean;
};

const termNotReadyForProd: string[] = [];

// Disbaled all health products in production
// as KYC is not enabled yet.
const healthNotReadyForProd: string[] = [
  // Enabled on dev/staging (Sep 02, 2026) for testing. Kept off production
  // until Business gives the go ahead.
  HEALTH_INSURANCE_PRODUCTS.CARE_ULTIMATE
];

let termProducts: string[] = [];
let healthProducts: string[] = [];
const productsNotAvailableOnFq: string[] = [
  /* Term */
  TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_LIFE, // Discontinued from 1st Sept
  TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPER, // Discontinued from 24th July, 2025
  TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPREME, // Disabled on 6th Feb, 2026.
  TERM_INSURANCE_PRODUCTS.SMART_SECURE_PLUS, // Disabled for now (July 2024). Will be enabled later.
  TERM_INSURANCE_PRODUCTS.I_PROTECT_SMART, // Disabled on 18th July 2025 (Discontinued)
  /* Health */
  // Care
  HEALTH_INSURANCE_PRODUCTS.CARE_WITH_NCB, // Disabled as required Abacus API changes.
  HEALTH_INSURANCE_PRODUCTS.CARE_ADVANTAGE,
  HEALTH_INSURANCE_PRODUCTS.CARE_PLUS_COMPLETE,
  HEALTH_INSURANCE_PRODUCTS.CARE_PLUS_YOUTH,
  // ERGO
  HEALTH_INSURANCE_PRODUCTS.OPTIMA_RESTORE, // Discontinued on Sep 15th, 2025
  HEALTH_INSURANCE_PRODUCTS.ENERGY_SILVER // Disabled on Sep 15th, 2025
];

if (import.meta.env.VITE_APP_STAGE === APP_STAGE_PRODUCTION) {
  termProducts = Object.values(TERM_INSURANCE_PRODUCTS).filter(
    (product) => !termNotReadyForProd.includes(product)
  );
  healthProducts = Object.values(HEALTH_INSURANCE_PRODUCTS).filter(
    (product) => !healthNotReadyForProd.includes(product)
  );
} else if (
  import.meta.env.VITE_APP_STAGE === APP_STAGE_DEVELOPMENT ||
  import.meta.env.VITE_APP_STAGE === APP_STAGE_STAGING
) {
  termProducts = Object.values(TERM_INSURANCE_PRODUCTS);
  healthProducts = Object.values(HEALTH_INSURANCE_PRODUCTS);
}

const config: AppConfig = {
  APP_VERSION: packageJson.version,

  APP_STAGE: import.meta.env.VITE_APP_STAGE,
  IS_DEV: import.meta.env.VITE_APP_STAGE === APP_STAGE_DEVELOPMENT,
  IS_PROD: import.meta.env.VITE_APP_STAGE === APP_STAGE_PRODUCTION,
  // cookie domain to store utm,referral tags etc
  COOKIE_DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN,
  //BE API end point
  INSURANCE_API: import.meta.env.VITE_INSURANCE_API,
  // sentry
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV,
  TURN_STILE_TOKEN: import.meta.env.VITE_TURN_STILE_TOKEN,
  //products
  TERM_PRODUCTS: termProducts,
  HEALTH_PRODUCTS: healthProducts,
  PRODUCTS_NOT_AVAILABLE_ON_FQ: productsNotAvailableOnFq,

  BILLDESK_SOURCES: {
    module: import.meta.env.VITE_BILLDESK_MODULE_SOURCE,
    noModule: import.meta.env.VITE_BILLDESK_NO_MODULE_SOURCE,
    css: import.meta.env.VITE_BILLDESK_CSS_SOURCE
  },
  // MLI Document upload URL
  MLI_DOC_UPLOAD_URL: import.meta.env.VITE_MLI_DOC_UPLOAD_URL,

  // Enable or disable dark mode across the app
  DARK_MODE: import.meta.env.VITE_DARK_MODE === 'true'
};

export default { ...config };
